var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoiceCallerIcon = function SvgVoiceCallerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 65,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 64,
    x: 0.5,
    y: 0.5,
    stroke: "#DCDFE3",
    rx: 9.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M14 14h38v37H14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2329",
    fillRule: "evenodd",
    d: "M41.383 46.421c-.502 0-1-.08-1.476-.235-9.894-3.233-17.66-10.794-20.98-20.427a4.42 4.42 0 0 1 1.12-4.625l1.9-1.85a2.57 2.57 0 0 1 3.563 0l3.491 3.4c.73.707.942 1.776.535 2.697l-1.627 3.696c1.397 3.92 4.56 7.002 8.586 8.364l3.796-1.584a2.56 2.56 0 0 1 2.77.52l3.492 3.4a2.41 2.41 0 0 1 0 3.468l-1.9 1.85a4.68 4.68 0 0 1-3.27 1.326M23.745 19.353c-.46-.001-.9.177-1.223.494l-1.896 1.861a3.66 3.66 0 0 0-.93 3.854c3.247 9.383 10.819 16.744 20.46 19.892a3.9 3.9 0 0 0 3.958-.906l1.896-1.846c.326-.316.509-.744.509-1.191s-.183-.876-.509-1.191l-3.51-3.396a1.76 1.76 0 0 0-1.905-.358l-3.934 1.642a.4.4 0 0 1-.281 0c-4.368-1.428-7.796-4.766-9.263-9.019a.38.38 0 0 1 0-.274l1.686-3.83a1.64 1.64 0 0 0-.348-1.835l-3.487-3.396a1.73 1.73 0 0 0-1.223-.5",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009FDB",
    fillRule: "evenodd",
    d: "M39.384 31.729h-.791c-.003-2.582-2.151-4.674-4.802-4.676v-.77c3.087.004 5.589 2.44 5.593 5.445m-5.593-9.659v.77c5.04.005 9.124 3.982 9.128 8.889h.792c-.007-5.332-4.444-9.653-9.92-9.659m0-4.216v.77c3.57 0 6.993 1.381 9.517 3.839 2.523 2.457 3.941 5.79 3.941 9.266h.792c0-7.663-6.38-13.875-14.25-13.875",
    clipRule: "evenodd"
  })));
};
export default SvgVoiceCallerIcon;